import { useMutation } from "@tanstack/react-query";

import { useToasts } from "app/pages/activation/hooks/helpers/useToasts";
import { translate } from "app/filters/i18nFilter";
import { createActivationApi } from "app/pages/activation/services/api";

const DELETE_TOPICS_MUTATION_KEY = "DELETE_TOPICS";

export const useDeleteTopicsMutation = () => {
    const { showErrorToast } = useToasts();

    return useMutation({
        mutationFn: ({
            activationId,
            topicsId,
            shouldRemoveKWList,
        }: {
            activationId: string;
            topicsId: string[];
            shouldRemoveKWList: boolean;
        }) => {
            const api = createActivationApi();

            return api.topics.delete(activationId, topicsId, shouldRemoveKWList);
        },
        mutationKey: [DELETE_TOPICS_MUTATION_KEY],
        onError(error: Error) {
            showErrorToast(translate("common.api.error", { error: error?.message }));
        },
    });
};
